import SliderControl from './SliderControl'
import SelectControl from './SelectControl'
import ColorPickerControl from './ColorPickerControl'
import StyleEditor from './StyleEditor'
import { TemplateProvider, useTemplate } from './TemplateProvider'
import TemplateSwitcher from './TemplateSwitcher'
import {
  Text,
  View,
  Font,
  Svg,
  Path,
  StyleSheet,
  DocumentPage,
  Document,
  Page,
  useStyle,
} from './DocumentPage'
import fonts from './fonts'

const getTemplateStyle = (templates) =>
  templates
    .map((t, index) => ({
      [`template-${index}`]: t.defaultStyle || {},
    }))
    .reduce((acc, val) => ({ ...acc, ...val }), {})

const getTemplateSupported = (templates) =>
  templates
    .map((t, index) => ({
      [`template-${index}`]: Object.keys(t?.defaultStyle || {}),
    }))
    .reduce((acc, val) => ({ ...acc, ...val }), {})

const initializeTemplates = (templates) => {
  const templateStyle = getTemplateStyle(templates)
  const templateSupported = getTemplateSupported(templates)
  return [templates, templateStyle, templateSupported]
}

const builtinFonts = ['Helvetica', 'Courier']

const availableFontNames = [
  ...builtinFonts,
  ...fonts.map((font) => font.family),
].sort()

export {
  StyleEditor,
  SliderControl,
  SelectControl,
  ColorPickerControl,
  TemplateProvider,
  useTemplate,
  useStyle,
  TemplateSwitcher,
  Text,
  View,
  Font,
  Svg,
  Path,
  fonts,
  availableFontNames,
  StyleSheet,
  DocumentPage,
  initializeTemplates,
  Document,
  Page,
}
